import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import * as Yup from 'yup';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  Tooltip,
  TextField,
  ThreeFolders,
} from 'web-components';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
});

type Props = {
  label: string;
  isOpen: boolean;
  folderName?: string;
  appearance?: string;
  closeButton?: boolean;
  buttonLabel: string;
  buttonTooltip?: string;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddEntity = ({
  label,
  isOpen,
  folderName,
  appearance = 'primary',
  closeButton,
  buttonLabel,
  buttonTooltip,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title={label}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        name: '',
      }}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <Flex
          column
          width="100%"
          as="form"
          spacing={15}
          onSubmit={formikProps.handleSubmit}
        >
          <Field
            autoFocus
            name="name"
            label="Enter name"
            component={TextField}
          />
          {folderName && (
            <ThreeFolders
              selectedId={formikProps.values.folder_id}
              folderName={folderName}
              onSelect={(id) => {
                formikProps.setFieldValue('folder_id', id);
              }}
            />
          )}
          <Flex
            width="100%"
            justify={closeButton ? 'center' : 'flex-end'}
            spacing={20}
          >
            {closeButton && (
              <Button
                ghost
                appearance="danger"
                spacing="large"
                onClick={onRequestClose}
              >
                Close
              </Button>
            )}
            {buttonTooltip ? (
              <Tooltip
                body={buttonTooltip}
                positions={['left']}
                toggleMode
                initialState
              >
                <Button
                  ghost
                  appearance={appearance || 'primary'}
                  type="submit"
                  spacing="large"
                  isLoading={formikProps.isSubmitting}
                  isDisabled={formikProps.isSubmitting}
                >
                  {buttonLabel}
                </Button>
              </Tooltip>
            ) : (
              <Button
                ghost
                appearance={appearance || 'primary'}
                type="submit"
                spacing="large"
                isLoading={formikProps.isSubmitting}
                isDisabled={formikProps.isSubmitting}
              >
                {buttonLabel}
              </Button>
            )}
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default AddEntity;
